// Components
import ProviderLoginComponent from "@Settings/helpers/AdministrationTools/Provider/ProviderLoginComponent";
import DoubleStepLoginVariant from "@Settings/Layouts/FormVariants/DoubleStepLoginVariant";

// Types
import { AuthenticationType, CapitalizedRoles } from "@Settings/types/Common/auth";
import { AuthRoleStatus, TSelectedProvider } from "@Settings/types/administrationTools/utils";

type StepRouterProps = Readonly<{
	isMultiStep: boolean;
	isError: boolean;
	error: Error | null;
	authType?: AuthenticationType;
	isLoading: boolean;
	disabled: boolean;
	selectedProvider: (Partial<TSelectedProvider> & { authRoleStatuses: AuthRoleStatus[] }) | null;
	// Callbacks
	onLogout?: (role: CapitalizedRoles) => void;
	onChangeProvider?: (provider: Partial<TSelectedProvider>) => void;
}>;

export default function StepRouter(props: StepRouterProps) {
	const { isMultiStep = false } = props;

	if (isMultiStep) {
		return <DoubleStepLoginVariant {...props} />;
	}

	return <ProviderLoginComponent {...props} />;
}
